import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "../ui/skeleton";
export const AccreditationMarqueeLoader = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex justify-between gap-3 overflow-hidden p-2">{[...Array(5)].map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(_, i) {
  return <div key={i}><Skeleton className="mb-2 aspect-9/4 h-14 w-32 rounded-md px-1 py-2" /><Skeleton className="h-3.75" /></div>;
}